import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Switch from 'react-ios-switch'

import { Button } from 'controls'
import { colors } from 'theme'

import AppointmentStatus from './AppointmentStatus'

import info from './styles'

export default class extends PureComponent {
  static propTypes = {
    event: PropTypes.object,
    eventVisited: PropTypes.bool.isRequired,
    onChangeSaveData: PropTypes.func.isRequired
  }

  render() {
    const {
      event: {
        start,
        landlord = {},
        broker = {},
        valuationData,
        status
      },
      eventVisited,
      onChangeSaveData
    } = this.props

    return (
      <div className="content">
        <h4 className="header highlight">
          {broker.firstName} {broker.lastName} {broker.secondLastName}
        </h4>

        <h4 className="header">Cita de Valuación</h4>

        <p className="label">Ubicación:</p>
        <p className="value">
          {valuationData.address} <br />
          <a
            className="highlight"
            target="_blank"
            href={`https://www.google.com/maps/search/?api=1&query=${valuationData.lat},${valuationData.lng}`}
          >
            Ver en Google Maps
          </a>
        </p>

        <p className="label">Usuario:</p>
        <p className="value">
          {landlord.firstName} {landlord.lastName} {landlord.secondLastName}
        </p>

        <p className="label">Mail:</p>
        <p className="value">{landlord.email}</p>

        <p className="label">Telefónos:</p>

        <p className="value container-phones">
          {landlord.telephone}
          {status === 'CONFIRMED' && (
            <Button className="confirm-appointment" size="small" color="success">
              CONFIRMADA
            </Button>
          )}
        </p>
        {landlord.secondTelephone && (
          <p className="value">{landlord.secondTelephone}</p>
        )}

        {new Date().valueOf() >= start &&
          (status === 'PENDING' || status === 'CONFIRMED') && (
            <p className="label action-switch">
              Se realizó la cita:
              <Switch
                pendingOnColor={colors.primary}
                checked={eventVisited}
                onChange={eventVisited => onChangeSaveData({ eventVisited })}
              />
            </p>
          )}
        {new Date().valueOf() >= start &&
          (status === 'PENDING' || status === 'CONFIRMED') && (
            <AppointmentStatus
              className="appointmentStaus"
              eventVisited={eventVisited}
              onChangeSaveData={this.props.onChangeSaveData}
            />
          )}

        <style jsx>{info}</style>
      </div>
    )
  }
}
